import {DeltaEventMethodType} from "../../../gd/manager/delta-handler/types"
import Resources from "../../resources"
import {EntityType} from "../../../gd/const/item"

// const debug = "checkExpenseRelevance"
const debug = false

export function checkExpenseRelevance(resources:Resources, method: DeltaEventMethodType, data:any, header:any) {

    debug && console.log(debug, 'process', method, data, header)

    switch (method) {

        case DeltaEventMethodType.NEW   :

            // filter out from other projects
            if (resources.relevanceSettings?.tasks) {
                // patch
                const taskId : ID = data.taskId || header.expense?.taskId

                if (!resources.relevanceSettings.tasks.includes(taskId)) {
                    return false
                }
            }

            // filter out from other projects
            if (resources.relevanceSettings?.projects) {

                const projectId : ID = data.projectId || header.expense.projectId

                if (!resources.relevanceSettings.projects.includes(projectId)) {
                    return false
                }
            }

            if (resources.relevanceSettings?.customFunctions) {
                const isFilteredOut = _.some(resources.relevanceSettings?.customFunctions, customFunction => {
                    return !customFunction(EntityType.EXPENSE, method, data, header)
                })

                if (isFilteredOut) {
                    return false
                }
            }

            return true

        case DeltaEventMethodType.DELTA:
        case DeltaEventMethodType.DELETE:

            // if we have no resource we can't delete it...
            return !!resources.expenses?.get(header.expense.id)

    }


}